const state = {
	name: "",
	size: "",
	type: "",
	hp: 0,
	traits: [],
}

const getters = {
	get: (state) => (property) => {
		return state[property]
	},
}

const mutations = {
	set (state, payload){
		state[payload.property] = payload.value
	},
	setMultiple (state, items) {
		for(const item in items){
			state[item] = items[item]
		}
	},
	updateTrait (state, trait) {
		state.traits[trait.index] = trait.value
	},
	removeTrait (state, index) {
		state.traits.splice(index,1)
	},
	addTrait (state) {
		state.traits.push({
			name:"",
			description:"",
		})
	}
}

const actions = {
	loadCharacter ({ commit }, character) {
		commit('setMultiple', {
			name: character.Bio.Race.Name,
			size: character.Bio.Race.Size,
			type: character.Bio.Race.Type,
			hp: character.Bio.Race['Hit Points'],
		})
		var traits = []
		for(const index in character.Bio.Race.Properties){
			traits[index] = {
				name: character.Bio.Race.Properties[index].Name,
				description: character.Bio.Race.Properties[index].Description,
			}
		}
		commit('set',{
			property: 'traits',
			value: traits
		})
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}